/*
  Stuga email guard — attaches to every storefront email field that posts to
  Shopify: Dawn newsletter footer/section, contact page, and the Shopify Forms
  popup (which renders inside an open shadow root, so events are resolved via
  composedPath and styles are injected into that root). Blocks obviously dead
  domains, throwaway inboxes and placeholder addresses, and offers a one-click
  fix for common domain typos. Progressive: if this file fails to load the
  forms behave exactly as stock Dawn.
*/
(function () {
  'use strict';

  var FIELD = 'input[name="contact[email]"]';

  // Domains we see on the real subscriber list. Typos are measured against these.
  var KNOWN = [
    'gmail.com', 'googlemail.com', 'hotmail.com', 'hotmail.com.au', 'hotmail.co.uk',
    'outlook.com', 'outlook.com.au', 'live.com', 'live.com.au', 'msn.com',
    'yahoo.com', 'yahoo.com.au', 'yahoo.co.uk', 'yahoo.co.in', 'ymail.com', 'y7mail.com',
    'icloud.com', 'me.com', 'mac.com',
    'bigpond.com', 'bigpond.net.au', 'optusnet.com.au', 'optushome.com.au',
    'iinet.net.au', 'tpg.com.au', 'ozemail.com.au', 'westnet.com.au', 'internode.on.net',
    'wideband.net.au', 'iimetro.com.au', 'dodo.com.au', 'aapt.net.au', 'exemail.com.au',
    'protonmail.com', 'proton.me', 'pm.me', 'passmail.com', 'aol.com', 'mail.com',
    'zoho.com', 'yandex.com', 'naver.com', 'gmx.com', 'fastmail.com', 'hey.com'
  ];

  // TLDs that are almost always a mistyped .com / .com.au / .net
  var BAD_TLDS = [
    'con', 'cmo', 'comm', 'coom', 'ocm', 'om', 'cpm', 'vom', 'xom', 'cim', 'cok', 'col', 'cm', 'co,', 'c0m', 'coma', 'comau', 'comm.au', 'con.au', 'cm.au', 'com.ay', 'com.aj', 'com.a', 'com.uk', 'net.ay', 'ney', 'nte', 'ogr', 'orgg'
  ];

  var DISPOSABLE = [
    '10minutemail.com', '10minutemail.net', '10minemail.com', '20minutemail.com', '33mail.com', 'anonbox.net', 'anonymbox.com',
    'binkmail.com', 'bobmail.info', 'burnermail.io', 'byom.de', 'chacuo.net', 'crazymailing.com', 'cuvox.de',
    'dayrep.com', 'deadaddress.com', 'despam.it', 'discard.email', 'discardmail.com', 'dispostable.com', 'dropmail.me',
    'emailondeck.com', 'emailfake.com', 'emailtemporario.com.br', 'ethereal.email', 'fakeinbox.com', 'fakemail.net', 'fakemailgenerator.com',
    'filzmail.com', 'getairmail.com', 'getnada.com', 'gishpuppy.com', 'guerrillamail.com', 'guerrillamail.net', 'guerrillamail.org',
    'guerrillamail.biz', 'guerrillamail.de', 'guerrillamail.info', 'guerrillamailblock.com', 'grr.la', 'harakirimail.com', 'haltospam.com',
    'incognitomail.com', 'inboxbear.com', 'inboxkitten.com', 'jetable.org', 'jourrapide.com', 'kasmail.com', 'koszmail.pl',
    'lroid.com', 'mail-temp.com', 'mail-temporaire.fr', 'mail7.io', 'mailcatch.com', 'maildrop.cc', 'maildu.de', 'maileater.com',
    'mailexpire.com', 'mailforspam.com', 'mailinator.com', 'mailinator.net', 'mailinator2.com', 'mailnesia.com', 'mailnull.com',
    'mailsac.com', 'mailtemp.info', 'mailtothis.com', 'meltmail.com', 'mintemail.com', 'moakt.com', 'mohmal.com', 'mt2015.com',
    'mytemp.email', 'mytrashmail.com', 'nada.email', 'no-spam.ws', 'nomail.xl.cx', 'nospam.ze.tc', 'nowmymail.com', 'objectmail.com',
    'owlymail.com', 'pokemail.net', 'proxymail.eu', 'rcpt.at', 'rhyta.com', 'rtrtr.com', 'sharklasers.com', 'shitmail.me',
    'sogetthis.com', 'spam4.me', 'spamavert.com', 'spambog.com', 'spambox.us', 'spamfree24.org', 'spamgourmet.com', 'spamherelots.com',
    'spamhole.com', 'spaml.com', 'spamspot.com', 'spamthisplease.com', 'superrito.com', 'tafmail.com', 'teleworm.us', 'temp-mail.org',
    'temp-mail.io', 'tempail.com', 'tempemail.com', 'tempemail.net', 'tempinbox.com', 'tempmail.com', 'tempmail.de', 'tempmail.net',
    'tempmail.plus', 'tempmailo.com', 'tempmailaddress.com', 'tempr.email', 'temporaryemail.net', 'thankyou2010.com', 'throwam.com',
    'throwawaymail.com', 'tmail.ws', 'tmails.net', 'tmpmail.net', 'tmpmail.org', 'trash-mail.com', 'trash-mail.at', 'trashmail.com',
    'trashmail.at', 'trashmail.io', 'trashmail.me', 'trashmail.net', 'trashymail.com', 'wegwerfmail.de', 'wegwerfmail.net', 'wh4f.org',
    'yopmail.com', 'yopmail.fr', 'yopmail.net', 'zetmail.com', 'zippymail.info', 'zoemail.org'
  ];

  var PLACEHOLDER_DOMAINS = [
    'test.com', 'test.com.au', 'testing.com', 'example.com', 'example.org', 'example.net', 'example.com.au', 'email.com', 'mail.ru.invalid',
    'asdf.com', 'asd.com', 'abc.com', 'aaa.com', 'a.com', 'none.com', 'no.com', 'na.com', 'fake.com', 'fakemail.com', 'noemail.com',
    'nomail.com', 'null.com', 'domain.com', 'company.com', 'website.com', 'sample.com', 'xyz.com', 'qwerty.com', 'blah.com', 'spam.com'
  ];

  var PLACEHOLDER_LOCALS = [
    'test', 'testing', 'tester', 'asdf', 'asd', 'abc', 'qwerty', 'none', 'no', 'na', 'nah', 'fake', 'example', 'sample',
    'email', 'mail', 'noemail', 'nomail', 'nobody', 'null', 'nope', 'user', 'blah', 'spam', 'fuck', 'fuckoff', 'fu', 'xxx'
  ];

  // Real gTLDs that happen to start with com/net/org
  var REAL_LONG_TLDS = ['company', 'community', 'computer', 'condos', 'construction', 'consulting', 'contact', 'contractors', 'cooking', 'cool', 'coop', 'coupons', 'courses', 'network', 'organic'];
  function junkTld(tld) {
    return /^(com|net|org)[a-z]{1,5}$/.test(tld) && REAL_LONG_TLDS.indexOf(tld) === -1;
  }

  var MSG = {
    invalid: 'That doesn’t look like a real email address — please check it.',
    dead: 'That domain doesn’t look right — please check the part after the @.',
    disposable: 'Temporary inboxes can’t receive the welcome offer — please use your everyday email.',
    placeholder: 'Please use a real email address so the welcome offer can reach you.',
    typo: 'Did you mean '
  };

  function levenshtein(a, b) {
    if (a === b) return 0;
    var m = a.length, n = b.length;
    if (!m) return n;
    if (!n) return m;
    var prev = [], cur = [], prev2 = [], i, j;
    for (j = 0; j <= n; j++) { prev[j] = j; prev2[j] = 0; }
    for (i = 1; i <= m; i++) {
      cur[0] = i;
      for (j = 1; j <= n; j++) {
        cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
        if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) {
          cur[j] = Math.min(cur[j], prev2[j - 2] + 1); // transposition
        }
      }
      var t = prev2; prev2 = prev; prev = cur; cur = t;
    }
    return prev[n];
  }

  function suggestDomain(domain) {
    if (KNOWN.indexOf(domain) !== -1) return null;
    var best = null, bestDist = 99;
    for (var i = 0; i < KNOWN.length; i++) {
      var d = levenshtein(domain, KNOWN[i]);
      if (d < bestDist) { bestDist = d; best = KNOWN[i]; }
    }
    // One slip for short domains, two for long ones (bigpond.net.au etc.)
    var allowed = best && best.length >= 12 ? 2 : 1;
    return bestDist <= allowed ? best : null;
  }

  function endsWithDomain(domain, list) {
    for (var i = 0; i < list.length; i++) {
      var d = list[i];
      if (domain === d || domain.slice(-(d.length + 1)) === '.' + d) return true;
    }
    return false;
  }

  // Returns null when fine, otherwise { reason, message, suggestion? }
  function check(raw) {
    var value = (raw || '').trim();
    if (!value) return null; // let the browser's `required` handle empties
    var at = value.lastIndexOf('@');
    if (at < 1 || at === value.length - 1) return { reason: 'invalid', message: MSG.invalid };
    var local = value.slice(0, at);
    var domain = value.slice(at + 1).toLowerCase();

    if (/\s/.test(value) || local.indexOf('@') !== -1 || local.length > 64 || /^\.|\.$|\.\./.test(local)) return { reason: 'invalid', message: MSG.invalid };
    if (!/^[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)+$/.test(domain)) return { reason: 'invalid', message: MSG.invalid };

    var labels = domain.split('.');
    var tld = labels[labels.length - 1];
    var tld2 = labels.slice(-2).join('.');
    var suggestion = suggestDomain(domain);
    var fixed = suggestion ? local + '@' + suggestion : null;

    if (/\d/.test(tld) || tld.length < 2 || tld.length > 12 || junkTld(tld) || BAD_TLDS.indexOf(tld) !== -1 || BAD_TLDS.indexOf(tld2) !== -1) {
      return { reason: 'dead', message: fixed ? MSG.typo : MSG.dead, suggestion: fixed };
    }
    if (suggestion) return { reason: 'typo', message: MSG.typo, suggestion: fixed };
    if (endsWithDomain(domain, DISPOSABLE)) return { reason: 'disposable', message: MSG.disposable };

    var l = local.toLowerCase().replace(/[._-]/g, '');
    if (PLACEHOLDER_DOMAINS.indexOf(domain) !== -1 ||
        PLACEHOLDER_LOCALS.indexOf(l) !== -1 ||
        /^(.)\1{1,}$/.test(l) ||              // aaaa, xxxx
        /^\d{1,4}$/.test(l) ||               // 123, 1234
        /^(abc|123|1234|12345|asdf|qwe)+$/.test(l) ||
        l === labels[0]) {                   // asdf@asdf.com
      return { reason: 'placeholder', message: MSG.placeholder };
    }
    return null;
  }

  // ---------- UI ----------

  var SHADOW_HOST = 'shopify-forms-embed';
  var CSS =
    '.stuga-email-guard__msg{display:flex;align-items:baseline;gap:.6rem;margin-top:.8rem;text-align:left;font-size:1.3rem;line-height:1.5;color:rgba(var(--color-foreground,18,18,18),.85)}' +
    '.stuga-email-guard__icon{flex:none;display:inline-flex;justify-content:center;align-items:center;width:1.6rem;height:1.6rem;border-radius:50%;font-size:1.1rem;font-weight:700;line-height:1;color:rgb(var(--color-background,255,255,255));background:rgba(var(--color-foreground,18,18,18),.75);transform:translateY(.15rem)}' +
    '.stuga-email-guard__use{background:none;border:0;padding:0;margin:0 0 0 .3rem;font:inherit;color:inherit;font-weight:700;text-decoration:underline;text-underline-offset:.2rem;cursor:pointer}' +
    '.stuga-email-guard__use:hover{text-decoration-thickness:.2rem}';

  function ensureStyles(root) {
    var target = root === document ? document.head : root;
    if (!target || target.querySelector('style[data-stuga-guard]')) return;
    var css = document.createElement('style');
    css.setAttribute('data-stuga-guard', '');
    css.textContent = CSS;
    target.appendChild(css);
  }

  function isGuardedInput(el) {
    if (!el || el.tagName !== 'INPUT') return false;
    if (el.matches(FIELD)) return true;
    var root = el.getRootNode ? el.getRootNode() : null;
    var host = root && root.host;
    return !!(host && host.tagName && host.tagName.toLowerCase() === SHADOW_HOST && (el.type === 'email' || el.id === 'email'));
  }

  function inputFromEvent(e) {
    var path = e.composedPath ? e.composedPath() : [e.target];
    return isGuardedInput(path[0]) ? path[0] : null;
  }

  // Walk an event path up to its <form> and return the guarded email input inside it
  function formEmailFromPath(path) {
    for (var i = 0; i < path.length; i++) {
      var n = path[i];
      if (n && n.tagName === 'FORM') {
        var inputs = n.querySelectorAll('input');
        for (var k = 0; k < inputs.length; k++) if (isGuardedInput(inputs[k])) return inputs[k];
        return null;
      }
    }
    return null;
  }

  function msgFor(input) {
    var wrap = input.closest('.newsletter-form__field-wrapper') || input.closest('.field') || input.parentNode;
    var el = wrap.querySelector('.stuga-email-guard__msg');
    if (!el) {
      ensureStyles(input.getRootNode ? input.getRootNode() : document);
      el = document.createElement('small');
      el.className = 'newsletter-form__message form__message stuga-email-guard__msg';
      el.setAttribute('role', 'alert');
      el.hidden = true;
      var field = input.closest('.field') || input;
      field.parentNode.insertBefore(el, field.nextSibling);
    }
    return el;
  }

  function clear(input) {
    var el = msgFor(input);
    el.hidden = true;
    el.textContent = '';
    input.removeAttribute('aria-invalid');
    input.dataset.guardBad = '';
  }

  function show(input, result) {
    var el = msgFor(input);
    el.textContent = '';
    var icon = document.createElement('span');
    icon.className = 'stuga-email-guard__icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.textContent = '!';
    el.appendChild(icon);
    el.appendChild(document.createTextNode(result.message));
    if (result.suggestion) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'stuga-email-guard__use';
      btn.textContent = result.suggestion;
      btn.addEventListener('click', function () {
        setValue(input, result.suggestion);
        clear(input);
        input.focus();
      });
      el.appendChild(btn);
      el.appendChild(document.createTextNode('?'));
    }
    el.hidden = false;
    input.setAttribute('aria-invalid', 'true');
    input.dataset.guardBad = '1';
  }

  // Set the value in a way React-controlled inputs (Shopify Forms) notice
  function setValue(input, value) {
    var proto = Object.getPrototypeOf(input);
    var desc = Object.getOwnPropertyDescriptor(proto, 'value');
    if (desc && desc.set) desc.set.call(input, value); else input.value = value;
    input.dispatchEvent(new Event('input', { bubbles: true, composed: true }));
    input.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
  }

  function validate(input) {
    var result = check(input.value);
    if (result) show(input, result); else clear(input);
    return !result;
  }

  function block(e, input) {
    e.preventDefault();
    e.stopImmediatePropagation();
    input.focus();
  }

  document.addEventListener('focusout', function (e) {
    var input = inputFromEvent(e);
    if (input) validate(input);
  });

  document.addEventListener('input', function (e) {
    var input = inputFromEvent(e);
    // Re-check live once we've shown a message, so the fix clears it immediately
    if (input && input.dataset.guardBad) validate(input);
  });

  // Light-DOM forms (Dawn newsletter, contact page)
  document.addEventListener('submit', function (e) {
    var input = formEmailFromPath([e.target]);
    if (input && !validate(input)) block(e, input);
  }, true);

  // Shadow-DOM forms never bubble submit out, so intercept the click / Enter that triggers it
  document.addEventListener('click', function (e) {
    var path = e.composedPath ? e.composedPath() : [e.target];
    var btn = null;
    for (var i = 0; i < path.length; i++) {
      var n = path[i];
      if (n && n.tagName === 'BUTTON' && n.type !== 'button' && n.type !== 'reset') { btn = n; break; }
      if (n && n.tagName === 'INPUT' && n.type === 'submit') { btn = n; break; }
    }
    if (!btn) return;
    var input = formEmailFromPath(path);
    if (input && !validate(input)) block(e, input);
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = inputFromEvent(e);
    if (input && !validate(input)) block(e, input);
  }, true);

  ensureStyles(document);

  window.StugaEmailGuard = { check: check };
})();
